import React from "react";
import { Button } from "@mui/material";
import EditIcon from "../../../assets/icons/editIcon.svg";
import { getNairaFormat } from "../../../utils/Utils";
import { canPerformAction } from "../../../utils/UserAuth";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ActivationModal, CreatePinModal } from "./CreateModals";
import { toast } from "react-toastify";
import { activateAsset } from "../utils";
import { checkForFinance } from "../../../utils/UserAuth";

/* eslint-disable */
const ActionSideBar = ({
	leaseData,
	action,
	setAction,
	handleCancel,
	canActivateAsset,
	handleAssetActivation,
}) => {
	const navigate = useNavigate();
	let { id: assetId } = useParams();
	const [modalOpen, setModalOpen] = useState(false);
	const [pinModalOpen, setPinModalOpen] = useState(false);
	const [currentStage, setCurrentStage] = useState("confirm1");

	const handleEdit = () => {
		setAction("edit");
	};

	// const handleModalOpen = () => {
	// 	setModalOpen(true);
	// };

	const handleModalClose = () => {
		setModalOpen(false);
		if (currentStage === "successful") {
			navigate(`/lease/active/${assetId}/?filter=quick_lease`);
		} else {
			setCurrentStage("confirm1");
		}
	};

	const handleActivateAsset = async (pinInput) => {
		const res = await activateAsset({ pin: pinInput, assetId });
		console.log(res);
		if (!res.error) {
			toast.success("Asset activated successfully");
			setCurrentStage("successful");
		} else {
			toast.error(res.error || "Error activating asset");
		}
	};

	return (
		<div className='LeftSection'>
			<div className='productDetails'>
				<img src={leaseData?.image || "/images/placeholder_img.jpg"} alt='product' />
				<h6>{leaseData?.productName || leaseData?.productId?.productName || "---"}</h6>
				<p>{getNairaFormat(leaseData?.amount)}</p>
			</div>

			{canPerformAction("edit", "lease") &&
				action &&
				(action === "view" ? (
					<Button
						variant='outlined'
						className='editButton'
						onClick={handleEdit}
						startIcon={<img src={EditIcon} alt='edit icon' />}>
						Edit Detail
					</Button>
				) : (
					<>
						<Button variant='contained' className='updateButton' type='submit'>
							Update
						</Button>
						<Button variant='outlined' className='cancelButton' onClick={handleCancel}>
							Cancel
						</Button>
					</>
				))}

			{/* //change to finance guy */}
			{canActivateAsset && checkForFinance() && (
				<Button
					variant='contained'
					color='success'
					onClick={handleAssetActivation}
					// onClick={handleModalOpen}
					sx={{ mt: 3, px: "48px !important" }}>
					Activate
				</Button>
			)}

			{modalOpen && (
				<ActivationModal
					modalOpen={modalOpen}
					handleModalClose={handleModalClose}
					handleActivateAsset={handleActivateAsset}
					currentStage={currentStage}
					setCurrentStage={setCurrentStage}
					setPinModalOpen={setPinModalOpen}
				/>
			)}

			{pinModalOpen && <CreatePinModal modalOpen={pinModalOpen} setPinModalOpen={setPinModalOpen} />}
		</div>
	);
};

export default ActionSideBar;
